import { render, staticRenderFns } from "./cableClamp.vue?vue&type=template&id=656efa28&scoped=true"
import script from "./cableClamp.vue?vue&type=script&lang=js"
export * from "./cableClamp.vue?vue&type=script&lang=js"
import style0 from "./cableClamp.vue?vue&type=style&index=0&id=656efa28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656efa28",
  null
  
)

export default component.exports